import { useLanguage } from '../../contexts/LanguageContext';
import { useData } from '../../contexts/DataContext';
import { useMediaQuery } from 'react-responsive';
import VisionDesktop from '../../components/Desktop/VisionDesktop';
import VisionMobile from '../../components/Mobile/VisionMobile';
// /Users/macair/Herd/youni-app/resources/js/components/Mobile/VisionMobile.jsx
const AboutCoreValues = () => {
  const { language } = useLanguage();
  const result = useData();
  const about = result.data.about;
  const isMobile = useMediaQuery({ minWidth: 0, maxWidth: 768 });

  const sharedProps = {
    about,
    language
  };

  return isMobile ? <VisionMobile {...sharedProps} /> : <VisionDesktop {...sharedProps} />;
};

export default AboutCoreValues;